// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"1467c51a","740":"c90bfb6d","766":"b45bcea4","887":"239741fb","987":"96f19056"}[chunkId] + ".chunk.js";
};